import { DateOrTimeView } from '@mui/x-date-pickers';
import {
  ConditionOperation,
  ConditionType,
  LogicalOperator,
  ReferenceType,
} from 'api/models/FieldTemplate';

export enum DateFieldDateTypes {
  Year = 'YYYY',
  Time = 'HH:MM',
  Date = 'YYYY.MM.DD',
  DateTime = 'YYYY.MM.DD-HH:MM',
}

export const DEFAULT_VALUE_OPTION_VISIT_DATE = 'visitDate';
export function getDatePickerViews(type?: string): DateOrTimeView[] {
  switch (type) {
    case DateFieldDateTypes.Year:
      return ['year'];
    case DateFieldDateTypes.Time:
      return ['hours', 'minutes'];
    case DateFieldDateTypes.Date:
      return ['year', 'month', 'day'];
    case DateFieldDateTypes.DateTime:
      return ['year', 'month', 'day', 'hours', 'minutes'];
    default:
      return ['year', 'month', 'day'];
  }
}

export function getEmptyCondition() {
  return {
    type: ConditionType.condition,
    operation: ConditionOperation.EQUALS,
    value: '',
    reference: {
      type: ReferenceType.formFieldReference,
    },
  };
}

export function getEmptyConditionGroup() {
  return {
    type: ConditionType.conditionGroup,
    operation: LogicalOperator.AND,
    conditions: [{ ...getEmptyCondition() }],
  };
}

export function getEmptyConditionGroupGroup() {
  return {
    type: ConditionType.conditionGroup,
    operation: LogicalOperator.AND,
    conditions: [{ ...getEmptyConditionGroup() }],
  };
}
